import { IChannel } from '@giphy/js-types'
import React from 'react'
import Carousel from 'shared/components/carousel/carousel'
import { AvatarBadge } from 'shared/components/users'
import { universalSearchPingBackEvent } from 'shared/pingbacks/pingback-networking'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import styled from 'styled-components'

const ScrollGuy = styled.div`
    display: flex;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    flex-direction: row;
    align-items: center;
    padding: 10px 0;
    margin-right: 6px;
`

const MiddleHeader = styled.div`
    display: flex;
    padding-bottom: 32px;
    flex-direction: column;
    align-items: flex-start;
`

const ChannelResults = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`
const StretchCarousel = styled(Carousel)`
    width: 100%;
`
// @ts-ignore
const Container = ({ paginates, ...props }) => (paginates ? PaginatedCarousel(props) : ScrollCarousel(props))

const PaginatedCarousel = ({ children, items }) => (
    <MiddleHeader>
        <ChannelResults>
            <StretchCarousel maxBlocks={4} title={`${items.length} channel${items.length > 1 ? `s` : ``}`}>
                {children}
            </StretchCarousel>
        </ChannelResults>
    </MiddleHeader>
)

const ScrollCarousel = ({ children }) => <ScrollGuy>{children}</ScrollGuy>

type Props = {
    searchResponseId: string
    items?: IChannel[]
    user: { id: number }
    paginates?: boolean
    css: any
}
const AvatarBadgeCarousel = ({ searchResponseId, items, css, paginates = false }: Props) =>
    items ? (
        <Container paginates={paginates} items={items}>
            {items.map(({ slug, display_name, user, id }, index) => (
                <AvatarBadge
                    user={user}
                    title={display_name}
                    key={index}
                    height={50}
                    css={{
                        containerStyle: css.channelContainer,
                        profileStyle: css.channelProfile,
                        titleStyle: css.channelsTitle,
                    }}
                    pingbackAnalytics={{
                        component: 'UNIVERSAL_SEARCH_CHANNEL',
                        data: [
                            { key: 'channel_id', value: id.toString() },
                            { key: 'channel_slug', value: slug },
                            { key: 'channel_display_name', value: display_name },
                            { key: 'channel_username', value: user.username },
                        ],
                        user: user,
                        pingbackRequest: universalSearchPingBackEvent,
                        searchResponseId: searchResponseId,
                        actionNames: {
                            seen: 'UNIVERSAL_SEARCH_CHANNEL_SEEN',
                            click: 'UNIVERSAL_SEARCH_CHANNEL_CLICK',
                            hover: 'UNIVERSAL_SEARCH_CHANNEL_HOVER',
                        },
                    }}
                    onClick={() =>
                        googleAnalyticsEvent({
                            category: `Search Page`,
                            action: `Channel Click`,
                            label: `${display_name}`,
                        })
                    }
                />
            ))}
        </Container>
    ) : null

export default AvatarBadgeCarousel
